/**
 * J 도전 과제 창.
 */

import Phaser from 'phaser';
import { ACHIEVE_ORDER, ACHIEVEMENTS } from '../data/achievements';
import { EV } from '../game/events';
import type { PlayerState } from '../systems/PlayerState';
import { COLOR, TEXT_COLOR, UI_FONT, UI_MONO } from './theme';

const WIDTH = 380;
const HEIGHT = 400;
const PAD = 14;

export class AchieveWindow {
  private readonly container: Phaser.GameObjects.Container;
  private readonly list: Phaser.GameObjects.Text;

  constructor(
    scene: Phaser.Scene,
    private readonly state: PlayerState,
  ) {
    const x = scene.scale.width / 2 - WIDTH / 2 - 40;
    const y = 64;
    this.container = scene.add.container(x, y).setVisible(false).setDepth(30);

    const g = scene.add.graphics();
    g.fillStyle(COLOR.panelEdge, 0.96);
    g.fillRoundedRect(-4, -4, WIDTH + 8, HEIGHT + 8, 12);
    g.fillStyle(COLOR.window, 0.98);
    g.fillRoundedRect(0, 0, WIDTH, HEIGHT, 10);
    this.container.add(g);

    this.container.add(
      scene.add.text(PAD, 10, '도전 과제', { fontFamily: UI_FONT, fontSize: '16px', color: TEXT_COLOR.dark }),
    );
    const close = scene.add
      .text(WIDTH - PAD, 12, '✕', { fontFamily: UI_MONO, fontSize: '14px', color: TEXT_COLOR.dark })
      .setOrigin(1, 0)
      .setInteractive({ useHandCursor: true });
    close.on('pointerdown', () => this.close());
    this.container.add(close);

    this.list = scene.add.text(PAD, 40, '', {
      fontFamily: UI_FONT,
      fontSize: '14px',
      color: TEXT_COLOR.dark,
      wordWrap: { width: WIDTH - PAD * 2, useAdvancedWrap: true },
      lineSpacing: 6,
    });
    this.container.add(this.list);
    state.events.on(EV.achieveChanged, this.refresh, this);
  }

  private refresh = (): void => {
    const lines = ACHIEVE_ORDER.map((id) => {
      const def = ACHIEVEMENTS[id];
      if (!def) return '';
      const on = this.state.unlockedAchievements.includes(id);
      return `${on ? '●' : '○'}  ${def.name}  (${def.hint})`;
    });
    this.list.setText(lines.join('\n'));
  };

  toggle(): boolean {
    this.container.setVisible(!this.container.visible);
    if (this.container.visible) this.refresh();
    return this.container.visible;
  }

  close(): void {
    this.container.setVisible(false);
  }

  get visible(): boolean {
    return this.container.visible;
  }

  destroy(): void {
    this.state.events.off(EV.achieveChanged, this.refresh, this);
    this.container.destroy();
  }
}
